import type PaymentMethods from '../PaymentMethods'

export class GetPaymentUrlRequest {
  /** (formato GUID, obligatorio): Identificador único de la cotización. */
  quotationId: string

  /** (string, opcional): URL a la que el sistema de pagos redirigirá una vez finalizado el proceso. */
  urlReturn: string

  /** (string, obligatorio): Método de pago. */
  paymentMethod: PaymentMethods

  constructor(data: any = {}) {
    this.quotationId = data.quotationId
    this.urlReturn = data.urlReturn
    this.paymentMethod = data.paymentMethod
  }
}
